import { render } from "./SpmPanelMenu.vue?vue&type=template&id=7060fd02"
import script from "./SpmPanelMenu.vue?vue&type=script&lang=ts"
export * from "./SpmPanelMenu.vue?vue&type=script&lang=ts"

import "./SpmPanelMenu.vue?vue&type=style&index=0&id=7060fd02&lang=scss"
script.render = render

export default script